import { CartAddEvent } from '@theme/events';

/**
 * Catapoux — ajout de l'upsell depuis le tiroir panier, sans rechargement.
 *
 * Délégation au niveau document : le listener survit aux re-rendus du tiroir
 * (Horizon remplace le markup du panier à chaque mise à jour).
 */

const FORM_SELECTOR = '.cx-upsell__form';
const REOPEN_DELAY = 350;

/** @param {Event} event */
async function handleSubmit(event) {
  const target = /** @type {HTMLElement | null} */ (event.target);
  const form = target?.closest?.(FORM_SELECTOR);
  if (!(form instanceof HTMLFormElement)) return;

  event.preventDefault();

  const button = form.querySelector('.cx-upsell__btn');
  if (button instanceof HTMLButtonElement) button.disabled = true;

  const drawerWasOpen = Boolean(document.querySelector('cart-drawer-component dialog[open]'));
  const addUrl = form.dataset.cxAddUrl || '/cart/add.js';

  try {
    const response = await fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: new FormData(form),
    });

    if (!response.ok) throw new Error(`cart/add returned ${response.status}`);

    document.dispatchEvent(new CartAddEvent({}, 'cx-upsell', { source: 'cx-upsell' }));

    if (drawerWasOpen) {
      setTimeout(() => {
        const drawer = document.querySelector('cart-drawer-component');
        const isOpen = Boolean(document.querySelector('cart-drawer-component dialog[open]'));
        if (drawer && !isOpen && typeof drawer.open === 'function') drawer.open();
      }, REOPEN_DELAY);
    }
  } catch (error) {
    // Repli : soumission native du formulaire (recharge et atterrit sur /cart).
    form.submit();
  }
}

document.addEventListener('submit', handleSubmit, true);
